import React from "react";
import PropTypes from "prop-types";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
} from "@mui/lab";
import { Alert } from "@mui/material";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";

/**
 * InstructionSteps Component
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of instruction steps
 * @param {string} props.heading - Heading to display above the timeline
 */
const InstructionSteps = ({ data = [], heading = "Instructions" }) => {
  return (
    <>
      <Alert
        variant="outlined"
        severity="warning"
        sx={{ bgcolor: "background.paper" }}
      >
        {heading}
      </Alert>
      <Timeline
        sx={{
          marginTop: "0px !important",
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        {data.map((step, index) => (
          <TimelineItem key={index} sx={{ minHeight: "50px" }}>
            <TimelineSeparator>
              <TimelineDot />
              {data.length - 1 !== index && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent>{step}</TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </>
  );
};

// Prop type validation
InstructionSteps.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
  heading: PropTypes.string,
};

export default InstructionSteps;
